import {useContext} from 'react'

import Box from 'components/Box'
import I18nContext from 'contexts/I18nContext'
import useBalanceTotal from 'hooks/helpers/useBalanceTotal'

import {UsdAmount, UsdLabel} from './PortfolioChart.styles'

const PortfolioChart = ({...rest}) => {
  const {t} = useContext(I18nContext)
  const {data: balance} = useBalanceTotal()
  return (
    <Box title={t('wallet.chart.title')} {...rest}>
      <UsdAmount>{balance == null ? '-' : balance}</UsdAmount>
      <UsdLabel>{t('wallet.chart.currentValue')}</UsdLabel>
    </Box>
  )
}

export default PortfolioChart
